export enum FaceDetectionWSChannelEnum {
  FACE_DETECTION = 'face-detection',
  LPR_DETECTION = 'lpr-detection',
  EVENTS = 'event',
  COUTING = 'counting',
}

export enum WebSocketRoomTypeEnum {
  LPR = 'lpr-room',
  FACE = 'face-room',
  EVENTS = 'event-room',
  COUNTING = 'counting-face-room',
}
